import { graphql } from "~/lib/graphql";

export const ResponsiveBannerFragment = graphql(`
  fragment ResponsiveBannerFragment on ResponsiveBannerRecord {
    __typename
    id
    banner {
      id
      url
      desktopBanner {
        id
        url
        width
        height
      }
      mobileBanner {
        id
        url
        width
        height
      }
    }
  }
`);
